
import {
  defineComponent,
  PropType,
  computed,
  ref,
  watch,
  onMounted,
} from "vue";
import { OnTheJobScoreEnum } from "@/types";
import { useVuelidate } from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";

export default defineComponent({
  name: "InputOnTheJobScore",
  props: {
    modelValue: {
      type: Number as PropType<OnTheJobScoreEnum>,
    },
    optionalCourse: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const values = computed(() => {
      return props.optionalCourse === true
        ? [
            { code: OnTheJobScoreEnum.Pass, description: "ผ่าน" },
            { code: OnTheJobScoreEnum.Fail, description: "ไม่ผ่าน" },
          ]
        : [
            { code: OnTheJobScoreEnum.R1_25, description: "ช่อง 1 (1-25%)" },
            { code: OnTheJobScoreEnum.R26_50, description: "ช่อง 2 (25-50%)" },
            { code: OnTheJobScoreEnum.R51_75, description: "ช่อง 3 (51-75%)" },
            {
              code: OnTheJobScoreEnum.R76_100,
              description: "ช่อง 4 (76-100%)",
            },
          ];
    });

    const onInputChange = (value: any) => {
      emit("update:modelValue", value.value);
    };
    const localValue = ref(0);

    const validateZero = (value: any) => {
      const result = (value ?? 0) !== 0 || props.required !== true;
      return result;
    };

    // const localRequired = ref(props.required);
    const rules = computed(() => ({
      localValue: {
        validateZero: helpers.withMessage(
          "กรุณาระบุผลคะแนนที่ได้รับ",
          validateZero
        ),
      },
    }));
    const v$ = useVuelidate(rules, { localValue }, { $autoDirty: true });

    watch(
      () => props.modelValue,
      () => {
        localValue.value = props.modelValue ?? 0;
      }
    );

    onMounted(() => (localValue.value = props.modelValue ?? 0));

    return { values, onInputChange, localValue, v$ };
  },
});
